<template>
    <div>
        <Table
            ref="tableRef"
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'email'">
                    {{ props.record.email }}
                    <EyeInvisibleOutlined v-if="props.record.email_visible" style="float: right;margin-top: 5px;cursor: pointer;" @click="handleShowEmail(props.record)"/>
                    <EyeOutlined v-if="!props.record.email_visible" style="float: right;margin-top: 5px;cursor: pointer;" @click="handleShowEmail(props.record)"/>
                </template>
            </template>

            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" :disabled="props.record.status_val == 1" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
                </template>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, onUnmounted } from "vue";
    import Table from "@/components/Table.vue";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { UserApi } from '@/api/UserApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { formatTimestamp, debounce, timestampToDate } from '@/utils/global';

    const { t } = useI18n()

    const props = defineProps({
        row: {
            type: Object,
            default: () => ({}),
        },
        tenantOptions: {
            type: Object,
            default: () => ({}),
        },
    })

    const table = ref({
        data: [],
        columns: [
            {
                title: t('user.sys_org'),
                dataIndex: 'tenant',
                key: 'tenant',
                // width: 100,
                resizable: true,
                ellipsis: true,
                fixed: 'left',
            },
            {
                title: t('base.email'),
                dataIndex: 'email',
                key: 'email',
                width: 220,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('base.version2'),
                dataIndex: 'version',
                key: 'version',
                // width: 100,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('user.platform'),
                dataIndex: 'platform',
                key: 'platform',
                // width: 100,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('user.protocol_type'), 
                dataIndex: 'protocol_type', 
                key: 'protocol_type',
                // width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('user.locale_language'), 
                dataIndex: 'locale_language',
                key: 'locale_language',
                // width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('user.create_timestamp'),
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                // width: 190,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('user.update_timestamp'),
                dataIndex: 'update_timestamp',
                key: 'update_timestamp',
                // width: 190,
                resizable: true,
                ellipsis: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                // x: 1500,
                y: 580,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                showSizeChanger: true,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const protocolTypeMap = reactive({
        1: t('user.privacy_policy'),
        2: t('user.warranty'),
    })

    const platformMap = reactive({
        0: t('base.app'),
        1: t('base.backend'),
        2: t('base.serviceTool'),
    })

    const handleChangePagination = (configs) => {
        table.value.configs.pagination.current = configs.current
        table.value.configs.pagination.pageSize = configs.pageSize
        getVersionList()
    }

    const handleShowEmail = (record) => {
        record.email_visible = !record.email_visible
        if(record.email_visible){
            record.email = record.email_desensitize.value
        }else{
            desensitizedData(record, {request_param: JSON.stringify(record.email_desensitize)})
        }
    }

    const desensitizedData = async (record,param) => {
        let res = await AdvancedFunApi.getInstance().desensitizedData(param, record.id)
        if(res.code === 0){
            record.email = res.data
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    const getVersionList = async()=>{
        let params = {
            user_id: props.row.id,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await UserApi.getInstance().getVersionList(params, page_num, page_size)
        if(res.code === 0){
            console.log(props.tenantOptions,'props.tenantOptions')
            res.data.records.length && res.data.records.forEach(item=>{
                item.tenant = props.tenantOptions[item.sys_org]
                item.version = item.version || '-'
                item.locale_language = item.locale_language || '-'
                item.platform = platformMap[item.platform] || '-'
                item.protocol_type = protocolTypeMap[item.protocol_type] || '-'
                item.create_timestamp = item.create_timestamp ? timestampToDate(item.create_timestamp * 1000) : '-'
                item.update_timestamp = item.update_timestamp ? timestampToDate(item.update_timestamp * 1000) : '-'
                item.email_visible = true
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    onMounted(()=>{
        getVersionList()
    })
</script>

<style lang="scss" scoped>

</style>